{
  "#TIMESTAMP": {
    "APP": "Timestamp Recording",
    "TITLE": "Timestamp Recording",
    "TITLE_QUERY": "Query",
    "TITLE_RESULT": "Results",
    "RECORD_TIMESTAMP": "Record",
    "QUERY": "Search",
    "QUERY_RESULT": "Results",
    "BACK": "Back",
    "NO_DATA": "No timestamps have been recorded.",
    "DEFAULT_CODE": "Normal",
    "ACTIONS": "Actions",
    "TABLE": {
      "TITLE": "Timestamps",
      "FROM": "From",
      "TO": "To",
      "APPLIED_FILTERS": "Applied Filters",
      "HEADER": {
        "TYPE": "Type",
        "CODE": "Code",
        "DATE": "Date",
        "TIME": "Timestamp"
      }
    },
    "TYPE": {
      "ARRIVAL": "Arrival",
      "DEPARTURE": "Departure"
    },
    "FIND": {
      "SUBMIT": "Search",
      "EMPLOYEE_NUMBER": "Employee Number",
      "FROM": "From",
      "TO": "To"
    },
    "RECORD": {
      "TITLE": "Record Timestamp",
      "EMPLOYEE": "Employee Number",
      "TYPE": "Status",
      "CODE": "Code",
      "TIMESTAMP": "Timestamp",
      "SUBMIT": "Record"
    },
    "MESSAGES": {
      "ADD_SUCCESS": {
        "TITLE": "Success",
        "MESSAGE": "The timestamp has been recorded."
      },
      "REMOVE_SUCCESS": {
        "TITLE": "Success",
        "MESSAGE": "The timestamp has been deleted."
      },
      "ADD_FAILURE": {
        "TITLE": "Error",
        "MESSAGE": "The timestamp could not be recorded."
      },
      "REMOVE_FAILURE": {
        "TITLE": "Error",
        "MESSAGE": "The timestamp could not be deleted."
      }
    },
    "ASK": {
      "CONFIRM_DELETE": "Do you really want to delete this timestamp?"
    },
    "NAVIGATE": {
      "PREVIOUS_DAY": "Previous Day",
      "NEXT_DAY": "Next Day"
    }
  },
  "#WORKHOURS": {
    "TITLE": "Today's Working Hours",
    "WEEK": "Weekly Hours",
    "PAUSE": "Today's Break Time"
  }
}
